import React, {useState} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {menuSelector} from "../../ducks/menu";
import {
  singularOfContentSelector,
  changeRootItem as changeRootItemAC
} from "../../ducks/content";
import Departments from "./Departments";
import Children from "./Children";

import styles from "./root-menu.module.scss";

function RootMenu({menu, productName, changeRootItem}) {
  const [activeDepartment, setActiveDepartment] = useState(menu[0].title);
  return (
    <div className={styles.root}>
      <Departments
        active={activeDepartment}
        items={menu}
        onClick={setActiveDepartment}
      />
      {menu.map(({title, children}) => (
        <Children
          key={title}
          activeItem={productName}
          onClick={changeRootItem}
          active={title === activeDepartment}
          items={children}
        />
      ))}
    </div>
  );
}

RootMenu.propTypes = {
  menu: PropTypes.array,
  productName: PropTypes.string,
  changeRootItem: PropTypes.func
};

export default connect(
  (state) => ({
    menu: menuSelector(state),
    productName: singularOfContentSelector(state)
  }),
  {
    changeRootItem: changeRootItemAC
  }
)(RootMenu);
